export default "__VITE_ASSET__DRdCKmmy__"